import { FC } from "react";
import { IconProps } from "./types";

export const SocialTwitterFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm3.922-15.916a4.685 4.685 0 0 0 1.493-.57 2.362 2.362 0 0 1-1.033 1.301 4.638 4.638 0 0 0 1.35-.37 4.766 4.766 0 0 1-1.173 1.218c.005.1.006.201.006.304 0 3.107-2.365 6.691-6.691 6.691a6.672 6.672 0 0 1-3.605-1.056c.137.015.277.025.418.029l.143.003a4.717 4.717 0 0 0 2.92-1.006 2.355 2.355 0 0 1-2.196-1.634 2.365 2.365 0 0 0 1.061-.04 2.355 2.355 0 0 1-1.886-2.306v-.03c.318.177.68.282 1.066.294a2.347 2.347 0 0 1-1.046-1.957c0-.43.115-.835.318-1.183a6.678 6.678 0 0 0 4.847 2.458 2.43 2.43 0 0 1-.06-.537 2.352 2.352 0 0 1 4.068-1.609z"
      fill={fill}
    />
  </svg>
);
